import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PolicyPopupComponent } from './policy-popup.component';

const routes: Routes = [{ path: '', component: PolicyPopupComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PolicyPopupRoutingModule { }
